/* eslint-disable react/no-unknown-property */
import  { useEffect, useState } from "react";
import { Button, Circle, ListBox, ListBoxItem, Map, Placemark, YMaps } from "react-yandex-maps";
import './SegmentMap.scss';
import DataTable from '../../modules/AdminPanel/Table/Datatable';

const RADIUSES = [
    {
        label: "1км",
        value: 1000,
    },
    {
        label: "3км",
        value: 3000,
    },
    {
        label: "5км",
        value: 5000,
    },
    {
        label: "10км",
        value: 10000,
    },
    {
        label: "20км",
        value: 20000,
    },
]

//function deleteRegion(geo_point,selected,setSelected) {}

export default function SegmentMap({ edit = false, open, value, onChange }) {
    const [selected, setSelected] = useState(value);
    const [radius, setRadius] = useState(RADIUSES[0]);
    const [isAddingGeoPoint, setIsAddingGeoPoint] = useState(false);
    const [tempGeoPoint, setTempGeoPoint] = useState([0, 0])
    const [showLabelInput, setShowLabelInput] = useState(false);
    const [newLabel, setNewLabel] = useState("");
    const [pendingLatLng, setPendingLatLng] = useState(null);
    const [editingGeoPoint, setEditingGeoPoint] = useState(null);
    const [isEditingLabel, setIsEditingLabel] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        onChange(selected);
    }, [selected]);

    // Определение полноэкранного режима
    useEffect(() => {
        const checkFullscreen = () => {
            setIsFullscreen(document.fullscreenElement !== null);
        };

        document.addEventListener('fullscreenchange', checkFullscreen);
        return () => document.removeEventListener('fullscreenchange', checkFullscreen);
    }, []);

    if (!open) return (<></>)
    const handleMouseMove = (event) => {
        if (!isAddingGeoPoint) {
            return;
        }

        setTempGeoPoint(event.get("coords"));
    }

    const handleMapClick = (event) => {
        if (!isAddingGeoPoint) {
            return;
        }

        const [lat, lng] = event.get("coords");
        // Проверяем псевдо-фуллскрин Яндекс.Карт
        const isYmapsFullscreen = document.body.classList.contains('ymaps-2-1-79-fullscreen');
        if (isYmapsFullscreen) {
            const label = `Метка ${selected.length + 1}`;
            setSelected([
                ...selected,
                {
                    label,
                    lat,
                    lng,
                    radius: radius.value,
                },
            ]);
            setIsAddingGeoPoint(false);
        } else {
            setPendingLatLng([lat, lng]);
            setShowLabelInput(true);
            setIsAddingGeoPoint(false);
        }
    }

    const handleClickAddGeoPoint = () => {
        setIsAddingGeoPoint(!isAddingGeoPoint);
    }

    const handleSaveLabel = () => {
        const label = newLabel.trim() ? newLabel.trim() : `Метка ${selected.length + 1}`;
        setSelected([
            ...selected,
            {
                label,
                lat: pendingLatLng[0],
                lng: pendingLatLng[1],
                radius: radius.value,
            },
        ]);
        setShowLabelInput(false);
        setNewLabel("");
        setPendingLatLng(null);
    }

    const handleCancelLabel = () => {
        setShowLabelInput(false);
        setNewLabel("");
        setPendingLatLng(null);
    };

    const handleEditLabel = (geoPoint) => {
        setEditingGeoPoint(geoPoint);
        setNewLabel(geoPoint.label);
        setIsEditingLabel(true);
    };

    const handleSaveEditLabel = () => {
        const label = newLabel.trim() ? newLabel.trim() : `Метка ${selected.findIndex(gp => gp.lat === editingGeoPoint.lat && gp.lng === editingGeoPoint.lng) + 1}`;
        setSelected(selected.map(gp => 
            gp.lat === editingGeoPoint.lat && gp.lng === editingGeoPoint.lng 
                ? { ...gp, label } 
                : gp
        ));
        setIsEditingLabel(false);
        setNewLabel("");
        setEditingGeoPoint(null);
    };

    const handleCancelEditLabel = () => {
        setIsEditingLabel(false);
        setNewLabel("");
        setEditingGeoPoint(null);
    };

    const handleRadius = (e, geo_point) => {
        if (e.target.value >= 0.5 && e.target.value<=10){
            geo_point.radius = e.target.value*1000
            const array = selected.filter((value) => (value.lat !== geo_point.lat) && (value.lng !== geo_point.lng));
            setSelected([...array]);
            setSelected([...array, geo_point]);
        }
        else if (e.target.value > 10 ) {
            geo_point.radius = 10*1000
            const array = selected.filter((value) => (value.lat !== geo_point.lat) && (value.lng !== geo_point.lng));
            setSelected([...array]);
            setSelected([...array, geo_point]);
        }
        else {console.log("Radius must be between 0 and 10")}
        //console.log(array)
        //selected.map((value) => {
        //    return ((value.lat !== geo_point.lat) && (value.lng !== geo_point.lng)) ? setSelected({...value, radius: e.target.value*1000}) : console.log("")
        //}){selected?.map((value) => setLabel([...label,{checked: false, lat:value.lat, lng:value.lng}]))}
    }



    function deleteFromSelected(geo_point) { //,selected,setSelected
        const array = selected.filter((value) => (value.lat !== geo_point.lat) && (value.lng !== geo_point.lng));
        setSelected([...array]);
        console.log('Array', array);
        console.log('DeleteSelected');
    }

    // Описание колонок для DataTable
    const columns = [
        {
            Header: 'Название метки',
            accessor: 'label',
            width: 220,
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>{row.original.label}</span>
                    {!edit && (
                        <button 
                            onClick={() => handleEditLabel(row.original)}
                            style={{
                                background: 'none',
                                border: '1px solid #007bff',
                                color: '#007bff',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'pointer',
                                marginLeft: '8px',
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#007bff';
                                e.target.style.color = 'white';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = 'transparent';
                                e.target.style.color = '#007bff';
                            }}
                        >
                            Изменить
                        </button>
                    )}
                </div>
            )
        },
        {
            Header: 'Радиус (км)',
            accessor: 'radius',
            width: 120,
            Cell: ({ row }) => (
                <span>{row.original.radius/1000}</span>
            )
        },
        {
            Header: 'Действия',
            accessor: 'actions',
            width: 120,
            Cell: ({ row }) => !edit && (
                <button className="delete-btn" onClick={() => deleteFromSelected(row.original)}>
                    Удалить
                </button>
            )
        },
    ];

    // Подготовка данных для DataTable
    const data = selected?.sort((a, b) => (a.lat - b.lat)).map(geo_point => ({
        ...geo_point,
        radius: geo_point.radius,
        label: geo_point.label,
    })) || [];

    return (
        <div >
        <YMaps>
            <Map
                defaultState={{
                    center: [55.75, 37.57],
                    zoom: 4,
                    controls: ['zoomControl', 'fullscreenControl'],
                }}
                modules={[
                    "control.ZoomControl",
                    "control.FullscreenControl",
                ]}
                options={{
                    autoFitToViewport: "always"
                }}
                onClick={handleMapClick}
                onMouseMove={handleMouseMove}
                width="100%"
                height="400px"
            >
                {!edit && <Button
                    data={{ content: isAddingGeoPoint ? "Отменить добавление" : "Добавить метку" }}
                    options={{ maxWidth: 180, selectOnClick: false }}
                    onClick={handleClickAddGeoPoint}
                />}
                <ListBox data={{ content: `Радиус (${radius.label})` }} >
                    {
                        RADIUSES.map((rad) => <ListBoxItem
                            key={rad.value}
                            data={{ content: rad.label }}
                            onClick={() => setRadius(rad)}
                            state={{ selected: rad.value === radius.value }}
                        />)
                    }
                </ListBox>
                {isAddingGeoPoint && (
                    <div>
                        <Placemark geometry={tempGeoPoint} onMouseMove={handleMouseMove} onClick={handleMapClick} />
                        <Circle geometry={[tempGeoPoint, radius.value]} options={{ fillColor: "#3F73F925" }} onMouseMove={handleMouseMove} onClick={handleMapClick} />
                    </div>
                )}
                {selected?.map((geo_point) =>
                    <div key={[geo_point.lat, geo_point.lng]}>
                        <Placemark geometry={[geo_point.lat, geo_point.lng]} />
                        <Circle geometry={[[geo_point.lat, geo_point.lng], geo_point.radius]} options={{ fillColor: "#3F73F925" }} />
                    </div>
                )}
            </Map>
        </YMaps >
        {showLabelInput && (
            <div className="label-modal-bg">
                <div className="label-modal">
                    <div style={{ marginBottom: 8 }}>Введите название метки:</div>
                    <input
                        type="text"
                        value={newLabel}
                        onChange={e => setNewLabel(e.target.value)}
                        placeholder={`Метка ${selected.length + 1}`}
                        autoFocus
                    />
                    <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                        <button onClick={handleSaveLabel} className="save-btn">Сохранить</button>
                        <button onClick={handleCancelLabel} className="delete-btn">Отмена</button>
                    </div>
                </div>
            </div>
        )}
        {isEditingLabel && (
            <div className="label-modal-bg">
                <div className="label-modal">
                    <div style={{ marginBottom: 8 }}>Изменить название метки:</div>
                    <input
                        type="text"
                        value={newLabel}
                        onChange={e => setNewLabel(e.target.value)}
                        placeholder="Введите новое название"
                        autoFocus
                    />
                    <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                        <button onClick={handleSaveEditLabel} className="save-btn">Сохранить</button>
                        <button onClick={handleCancelEditLabel} className="delete-btn">Отмена</button>
                    </div>
                </div>
            </div>
        )}
        <div className="segment-map-table">
            <DataTable columns={columns} data={data} />
        </div>
        </div>
    )
}
